const state = {
  injectedComponent: {
    name: null,
    props: {},
    on: null,
  },
};
const getters = {
  getInjectedComponent: (state) => state.injectedComponent,
};

const mutations = {
  setInjectedComponent(state, componentData) {
    state.injectedComponent = componentData;
  },
};

export default {
  state,
  getters,
  mutations,
};
